/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { Panel, PANEL_STYLE } from "../../../../ui/components/Panel";
import { IntegrationEditorDetails } from "./IntegrationEditorDetails";
import { IIntegrationType } from "../../../../integration/IntegrationServiceTypes";

export interface IIntegrationEditorSidebarContentProps {
	className?: string;
	integrationType?: IIntegrationType;
}

export const IntegrationEditorSidebarContent: React.FC<IIntegrationEditorSidebarContentProps> = ({
	className,
	integrationType
}) => {
	const baseClass = BEM("edt-integration-editor-sidebar-content");

	if (className) {
		baseClass.add(className);
	}

	return (
		<Panel style={PANEL_STYLE.NONE} scroll className={baseClass.toClassName()}>
			<IntegrationEditorDetails integrationType={integrationType} />
		</Panel>
	);
};
